import {
  PaymentAssignmentStatusId,
  Priority,
  PriorityList,
  PRIORITY_LABELS,
} from '../Utils/types'
import { sortPaymentAssignmentStatusesByDisplayOrder } from '../Utils/paymentAssignmentStatusOrder'

export const UNPAID_STATUSES: readonly PaymentAssignmentStatusId[] =
  sortPaymentAssignmentStatusesByDisplayOrder([
    PaymentAssignmentStatusId.PENDING_ASSIGNMENT,
    PaymentAssignmentStatusId.PENDING_PAYMENT,
    PaymentAssignmentStatusId.PENDING_AUTOPAY,
    PaymentAssignmentStatusId.UNPAID_ESCALATION,
    PaymentAssignmentStatusId.CARRIER_SHOW_PAYMENT,
  ])

export const BOT_STATUSES: readonly PaymentAssignmentStatusId[] =
  sortPaymentAssignmentStatusesByDisplayOrder([
    PaymentAssignmentStatusId.BOT_QUEUED,
    PaymentAssignmentStatusId.BOT_PROCESSING,
    PaymentAssignmentStatusId.BOT_SUBMITTED,
    PaymentAssignmentStatusId.BOT_CLEARED,
    PaymentAssignmentStatusId.BOT_FAILED,
    PaymentAssignmentStatusId.BOT_CANCELLED,
  ])

export const DEFAULT_STATUSES: readonly PaymentAssignmentStatusId[] =
  sortPaymentAssignmentStatusesByDisplayOrder([
    PaymentAssignmentStatusId.PENDING_ASSIGNMENT,
    PaymentAssignmentStatusId.PENDING_PAYMENT,
    PaymentAssignmentStatusId.PAYMENT_SUBMITTED,
    PaymentAssignmentStatusId.TERMINATED_EE,
    PaymentAssignmentStatusId.CARRIER_SHOW_PAYMENT,
    PaymentAssignmentStatusId.UNPAID_ESCALATION,
    PaymentAssignmentStatusId.PAYMENT_CLEARED,
    PaymentAssignmentStatusId.NEW_EFFECTIVE_DATE,
    PaymentAssignmentStatusId.TERMINATED_PLAN,
    PaymentAssignmentStatusId.PAID_ESCALATION,
    PaymentAssignmentStatusId.AP_CONFIRMED,
    PaymentAssignmentStatusId.ESCALATION_FULLY_RESOLVED,
    PaymentAssignmentStatusId.EE_PAID,
    PaymentAssignmentStatusId.BOT_SUBMITTED,
    PaymentAssignmentStatusId.BOT_CLEARED,
    PaymentAssignmentStatusId.BOT_FAILED,
  ])

export const TICKET_STATUSES: readonly PaymentAssignmentStatusId[] =
  sortPaymentAssignmentStatusesByDisplayOrder([
    PaymentAssignmentStatusId.PAYMENT_SUBMITTED,
    PaymentAssignmentStatusId.TERMINATED_EE,
    PaymentAssignmentStatusId.CARRIER_SHOW_PAYMENT,
    PaymentAssignmentStatusId.UNPAID_ESCALATION,
    PaymentAssignmentStatusId.PAYMENT_CLEARED,
    PaymentAssignmentStatusId.NEW_EFFECTIVE_DATE,
    PaymentAssignmentStatusId.TERMINATED_PLAN,
    PaymentAssignmentStatusId.PAID_ESCALATION,
    PaymentAssignmentStatusId.AP_CONFIRMED,
    PaymentAssignmentStatusId.ESCALATION_FULLY_RESOLVED,
    PaymentAssignmentStatusId.EE_PAID,
    PaymentAssignmentStatusId.BOT_SUBMITTED,
    PaymentAssignmentStatusId.BOT_CLEARED,
  ])

export const PRIORITY_STATUSES: readonly PaymentAssignmentStatusId[] =
  sortPaymentAssignmentStatusesByDisplayOrder([
    PaymentAssignmentStatusId.PAYMENT_SUBMITTED,
    PaymentAssignmentStatusId.TERMINATED_EE,
    PaymentAssignmentStatusId.CARRIER_SHOW_PAYMENT,
    PaymentAssignmentStatusId.UNPAID_ESCALATION,
    PaymentAssignmentStatusId.PAYMENT_CLEARED,
    PaymentAssignmentStatusId.NEW_EFFECTIVE_DATE,
    PaymentAssignmentStatusId.TERMINATED_PLAN,
    PaymentAssignmentStatusId.PAID_ESCALATION,
    PaymentAssignmentStatusId.AP_CONFIRMED,
    PaymentAssignmentStatusId.ESCALATION_FULLY_RESOLVED,
    PaymentAssignmentStatusId.EE_PAID,
    PaymentAssignmentStatusId.BOT_SUBMITTED,
    PaymentAssignmentStatusId.BOT_CLEARED,
  ])

export const DEFAULT_UNPAID_COUNTS: Record<string, number> = Object.fromEntries(
  UNPAID_STATUSES.map((s) => [s, 0])
)

export const PRIORITY_LEVELS = PriorityList.filter(
  (p) => p !== Priority.DEFAULT
).map(String)

export const PRIORITY_LEVEL_LABELS: Record<string, string> = Object.fromEntries(
  PriorityList.filter((p) => p !== Priority.DEFAULT).map((p) => [
    String(p),
    PRIORITY_LABELS[p],
  ])
)
